import * as React from 'react'
import Head from 'next/head'
import PageRoot, { Main, Nav, Header, Body } from './PageLayout.style'
import { useScreenWidth } from '../../theme/hooks/useScreenWidth'
import { TABLET } from '../../theme/breakpoints'
import { Job } from '../../../state/reducers/jobs/jobs'

const ACCOUNT_URL = '/account'
const DASHBOARD_URL = '/'

export type Props = {
  loggedIn: boolean
  onClickPlaceVacancy: () => void
  clickPlaceVacancyIsInProgress: boolean
  fullName: string
  onLogInOut: () => void
  menuIsOpen: boolean
  handleMenuToggle: (newValue?: boolean) => void
  withNavigation?: boolean
  title?: string
  className?: string
  itemsInCart?: number
  children?: React.ReactNode
  lastRejectedJob?: Job
}

const PageLayout: React.FunctionComponent<Props> = ({
  loggedIn,
  onClickPlaceVacancy,
  clickPlaceVacancyIsInProgress,
  fullName,
  onLogInOut,
  menuIsOpen,
  handleMenuToggle,
  itemsInCart,
  withNavigation = false,
  title = null,
  className = null,
  lastRejectedJob,
  children,
}) => {
  const width = useScreenWidth()
  const isDesktop = width >= TABLET
  const showMenu = (isDesktop && withNavigation) || menuIsOpen
  // Hides page content on small screens when menu is open, to prevent scrolling and interfering elements from the content
  const showContent = isDesktop || !menuIsOpen
  const titleText = title ? ` — ${title}` : ''

  return (
    <PageRoot>
      <Head>
        <title>{`DPG Recruitment Dashboard${titleText}`}</title>
      </Head>
      <Body className={className}>
        {showMenu && (
          <Nav
            onClickPlaceVacancy={onClickPlaceVacancy}
            clickPlaceVacancyIsInProgress={clickPlaceVacancyIsInProgress}
            isLoggedIn={loggedIn}
            onLogIn={onLogInOut}
            onLogOut={onLogInOut}
            itemsInCart={itemsInCart}
            lastRejectedJob={lastRejectedJob}
          />
        )}
        <Header
          accountUrl={ACCOUNT_URL}
          dashboardUrl={DASHBOARD_URL}
          menuIsOpen={menuIsOpen}
          onMenuToggle={handleMenuToggle}
          userName={fullName}
          isLoggedIn={loggedIn}
          onLogOut={onLogInOut}
          onLogIn={onLogInOut}
        />
        <Main hidden={!showContent}>{children}</Main>
      </Body>
    </PageRoot>
  )
}

export default PageLayout
